import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  // max width aligned with FormBuilder / CompanyInfoForm (theme.spacing(120))
  root: {
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: theme.spacing(120),
    marginLeft: 'auto',
    marginRight: 'auto',
    '& .MuiOutlinedInput-root:not(.Mui-disabled)': {
      backgroundColor: theme.palette.common.white,
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: theme.palette.action.hover,
      '& input, & textarea': {
        color: theme.palette.text.secondary,
        WebkitTextFillColor: theme.palette.text.secondary,
      },
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
    },
    '& .MuiInputLabel-outlined.Mui-disabled': {
      color: theme.palette.text.secondary,
    },
  },
  backButton: {
    marginBottom: theme.spacing(1),
  },
  infoCard: {
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  pageTitle: {
    marginBottom: theme.spacing(1),
  },
  sectionCard: {
    padding: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  checklistSectionCard: {
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
  },
  checklistSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.action.hover,
    cursor: 'pointer',
    userSelect: 'none',
    '&:focus:not(:focus-visible)': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  checklistSectionTitle: {
    fontWeight: 600,
  },
  checklistSectionBody: {
    padding: theme.spacing(2),
  },
  checklistItemCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    border: `1px solid ${theme.palette.divider}`,
  },
  checklistItemLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
  },
  expandIcon: {
    transition: 'transform 0.2s ease',
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
  findingsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  findingCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderLeft: `3px solid ${theme.palette.warning.main}`,
  },
  findingCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  findingDivider: {
    margin: theme.spacing(1.5, 0, 2),
  },
  totalsCard: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.action.hover,
  },
  totalLabel: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  totalFindingValue: {
    color: theme.palette.warning.main,
  },
  totalRecommendationValue: {
    color: theme.palette.primary.main,
  },
  totalBestPracticeValue: {
    color: theme.palette.success.main,
  },
  totalCommentValue: {
    color: theme.palette.info.main,
  },
  summaryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  detailedFindingsIntro: {
    marginBottom: theme.spacing(2),
  },
  footerCard: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  stickyFooterCard: {
    position: 'sticky',
    padding: `0 ${theme.spacing(1.5)}px`,
    bottom: 0,
    zIndex: 10,
  },
  progressRow: {
    minWidth: 220,
  },
  progressLabel: {
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  progressBar: {
    height: 8,
    borderRadius: 8,
  },
  footerActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
    gap: theme.spacing(1),
  },
  loadingButtonInline: {
    display: 'flex',
    alignItems: 'center',
    '& > .MuiGrid-item': {
      width: 'auto',
      maxWidth: 'none',
      flexBasis: 'auto',
      paddingTop: 0,
      height: 'auto',
    },
  },
  followUpHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  followUpBadge: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  followUpCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderLeft: `3px solid ${theme.palette.warning.main}`,
  },
  followUpCardTitle: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 600,
  },
  followUpFieldLabel: {
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
}));

export default useStyles;
